import { render } from "./EventsnPresentation.vue?vue&type=template&id=0261d82f&scoped=true"
import script from "./EventsnPresentation.vue?vue&type=script&lang=js"
export * from "./EventsnPresentation.vue?vue&type=script&lang=js"

import "./EventsnPresentation.vue?vue&type=style&index=0&id=0261d82f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0261d82f"]])

export default __exports__